import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import type { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import { API_URL, IS_SERVER } from '../config/constants';

const basePath = IS_SERVER ? API_URL.replace('/api', '') : window.location.origin;

const useCurrentPage: () => [(url: string) => boolean, string] = () => {
  const currentPage = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['router', 'location', 'pathname'], ''));

  const isCurrentPage = useCallback((url: string) => {
    try {
      // For absolute and relative link urls.
      const parsedUrl = url.startsWith('http') ? new URL(url) : new URL(url, basePath);
      return parsedUrl.origin === basePath && parsedUrl.pathname === currentPage;
    } catch (e) {
      console.error(e, url, currentPage);
    }

    return false;
  }, [currentPage]);

  return [isCurrentPage, currentPage];
};

export default useCurrentPage;
